import { BrowserRouter as Router, Routes, Route } from "react-router";
import { AuthProvider } from "@/react-app/contexts/AuthContext";
import ErrorBoundary from "@/react-app/components/ErrorBoundary";
import ProtectedRoute from "@/react-app/components/ProtectedRoute";
import Landing from "@/react-app/pages/Landing";
import AuthCallback from "@/react-app/pages/AuthCallback";
import Dashboard from "@/react-app/pages/Dashboard";
import Invoices from "@/react-app/pages/Invoices";
import Vendors from "@/react-app/pages/Vendors";
import Findings from "@/react-app/pages/Findings";
import Recoveries from "@/react-app/pages/Recoveries";
import Health from "@/react-app/pages/Health";
import Analytics from "@/react-app/pages/Analytics";
import Integrations from "@/react-app/pages/Integrations";
import Settings from "@/react-app/pages/Settings";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <ProtectedRoute>
                  <Invoices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vendors"
              element={
                <ProtectedRoute>
                  <Vendors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/findings"
              element={
                <ProtectedRoute>
                  <Findings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recoveries"
              element={
                <ProtectedRoute requiredRoles={['owner', 'admin', 'analyst']}>
                  <Recoveries />
                </ProtectedRoute>
              }
            />
            <Route
              path="/health"
              element={
                <ProtectedRoute>
                  <Health />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute requiredTiers={['pro', 'enterprise']}>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <ProtectedRoute requiredRoles={['owner', 'admin']}>
                  <Integrations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}
